import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueShepherd from 'vue-shepherd';
import GoogleAuth from 'vue-google-oauth'

Vue.use(VueShepherd);
Vue.use(GoogleAuth, { client_id: "656278031595-g9fvd281p5anbupftnfp457f0vhdpcd2.apps.googleusercontent.com" })
Vue.googleAuth().load()
Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
